<template>
  <div>
    <el-dialog
      :title="config.title"
      :visible.sync="config.visible"
      class="mini-dialog"
      :before-close="close"
    >
      <div>
        <el-form
          ref="operateForm"
          :model="operateForm"
          :rules="operateRules"
          label-width="150px"
          size="small"
        >
          <el-form-item label="序号">
            <el-input-number
              :disabled="config.type === 'detail'"
              class="w-280px"
              v-model="operateForm.seqNo"
              :min="0"
              controls-position="right"
            ></el-input-number>
          </el-form-item>
          <!-- 如果是新疆项目，固定的驾驶舱板块，在配置文件中配置 -->
          <template v-if="isXinJiang">
            <el-form-item label="名称" prop="name">
              <el-select
                v-model="operateForm.name"
                :disabled="config.type === 'detail'"
                placeholder="名称"
                filterable
                clearable
                @change="handleNameChange"
              >
                <el-option
                  v-for="item in xinJiangModule"
                  :key="item.code"
                  :label="item.name"
                  :value="item.name"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="编码" prop="code">
              <el-input
                readonly
                v-model="operateForm.code"
                placeholder="请输入编码"
              ></el-input>
            </el-form-item>
          </template>
          <template v-else>
            <el-form-item label="编码" prop="code">
              <el-input
                :readonly="config.type === 'detail'"
                v-model="operateForm.code"
                placeholder="请输入编码"
              ></el-input>
            </el-form-item>
            <el-form-item label="名称" prop="name">
              <el-input
                :readonly="config.type === 'detail'"
                v-model="operateForm.name"
                placeholder="请输入名称"
              ></el-input>
            </el-form-item>
          </template>
        </el-form>
      </div>
      <div slot="footer">
        <el-button type="primary" v-if="config.type !== 'detail'" @click="submitForm">保 存</el-button>
        <el-button @click="close">取 消</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { CockpitApi } from '@wiz-api/cloud-render-management'
import { get, find } from 'lodash'

const cockpitApi = new CockpitApi()

export default {
  props: {
    config: {
      type: Object,
      defalut: () => {
        return {
          visible: false,
          title: '',
          type: '',
          data: null,
        }
      },
    },
  },
  data() {
    return {
      currentId: '',
      operateForm: {
        seqNo: 0,
        code: '',
        name: '',
      },
      operateRules: {
        code: { required: true, message: '请输入编码', trigger: 'blur' },
        name: { required: true, message: '请输入名称', trigger: 'blur' },
      },
    }
  },
  computed: {
    isXinJiang() {
      return get(
        Wiz,
        'globalSettings.dynamicModules.modules["cloud-render-management"].config.isXinJiang'
      )
    },
    xinJiangModule() {
      return get(
        Wiz,
        'globalSettings.dynamicModules.modules["cloud-render-management"].config.xinJiangModule',
        []
      )
    },
  },
  created() {
    if (this.config.data) {
      this.operateForm.seqNo = this.config.data.seqNo
      this.operateForm.code = this.config.data.code
      this.operateForm.name = this.config.data.name
      this.currentId = this.config.data.id
    }
  },
  methods: {
    submitForm() {
      this.$refs.operateForm.validate(async (valid) => {
        if (valid) {
          let [err, res] = [null, {}]
          if (this.config.type === 'add') {
            ;[err, res] = await cockpitApi.create({
              body: this.operateForm,
            })
            if (!err) {
              this.$message.success('保存成功')
              this.$emit('operateSuccess')
              this.close()
            }
          } else if (this.config.type === 'edit' && this.currentId) {
            ;[err, res] = await cockpitApi.update(this.currentId, {
              body: { ...this.operateForm, id: this.currentId },
            })
            if (!err) {
              this.$message.success('保存成功')
              this.$emit('operateSuccess')
              this.close()
            }
          }
        }
      })
    },
    close() {
      this.$emit('close')
    },
    handleNameChange(value) {
      this.operateForm.code = get(find(this.xinJiangModule, ['name', value]),'code', '')
    }
  },
}
</script>

<style lang="scss" scoped>
::v-deep .el-input-number--small {
  width: 280px !important;
}
</style>
